// src/utils/helpers.js
const utils = {
    // Diziyi karıştır (Fisher-Yates algoritması)
    shuffleArray: function (array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    },

    // Mobil cihaz tespiti
    isMobile: function () {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },

    // [NEW] Custom Confirm Modal
    showConfirm: function (message, onConfirm, onCancel) {
        // Remove existing
        const existing = document.getElementById('custom-confirm-modal');
        if (existing) existing.remove();

        const modal = document.createElement('div');
        modal.id = 'custom-confirm-modal';
        Object.assign(modal.style, {
            position: 'fixed', top: '0', left: '0', width: '100%', height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.85)', zIndex: '20000',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            backdropFilter: 'blur(5px)', userSelect: 'none'
        });

        const box = document.createElement('div');
        Object.assign(box.style, {
            background: 'linear-gradient(135deg, #1a1a1a 0%, #000 100%)',
            border: '2px solid rgba(255, 215, 0, 0.4)', borderRadius: '15px',
            padding: '30px', textAlign: 'center', maxWidth: '400px', width: '90%',
            boxShadow: '0 0 40px rgba(0, 0, 0, 0.8), 0 0 10px rgba(255, 215, 0, 0.1) inset',
            animation: 'popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
        });

        // Add optional keyframe style if not exists (handled via js or css usually, simplistic here)
        // Using common styles/animations.css if available, or just simple scaling.

        const title = document.createElement('h3');
        title.innerText = "GADDAR BİLGİ";
        Object.assign(title.style, {
            color: '#ffd700', marginBottom: '15px', fontFamily: "'Cinzel', serif",
            marginTop: '0', fontSize: '1.4rem', borderBottom: '1px solid rgba(255,255,255,0.1)',
            paddingBottom: '10px'
        });
        box.appendChild(title);

        const msg = document.createElement('p');
        msg.innerText = message || "Emin misiniz?";
        Object.assign(msg.style, {
            color: '#ddd', marginBottom: '30px', fontSize: '1.1rem', lineHeight: '1.5'
        });
        box.appendChild(msg);

        const btnGroup = document.createElement('div');
        Object.assign(btnGroup.style, {
            display: 'flex', justifyContent: 'center', gap: '15px'
        });

        // Cancel Btn
        const noBtn = document.createElement('button');
        noBtn.innerText = "İPTAL";
        Object.assign(noBtn.style, {
            padding: '12px 30px', background: '#333', color: '#aaa',
            border: '1px solid #555', borderRadius: '8px', cursor: 'pointer',
            fontWeight: 'bold', fontSize: '0.9rem', transition: 'all 0.2s'
        });
        noBtn.onmouseenter = () => { noBtn.style.background = '#444'; noBtn.style.color = '#fff'; };
        noBtn.onmouseleave = () => { noBtn.style.background = '#333'; noBtn.style.color = '#aaa'; };
        noBtn.onclick = () => {
            modal.remove();
            if (onCancel) onCancel();
        };

        // Confirm Btn
        const yesBtn = document.createElement('button');
        yesBtn.innerText = "EVET";
        Object.assign(yesBtn.style, {
            padding: '12px 30px', background: 'darkred', color: 'white',
            border: '1px solid rgba(255, 215, 0, 0.5)', borderRadius: '8px', cursor: 'pointer',
            fontWeight: 'bold', fontSize: '1rem', transition: 'all 0.2s'
        });
        yesBtn.onmouseenter = () => { yesBtn.style.background = '#b30000'; yesBtn.style.boxShadow = '0 0 15px rgba(255,0,0,0.4)'; };
        yesBtn.onmouseleave = () => { yesBtn.style.background = 'darkred'; yesBtn.style.boxShadow = 'none'; };
        yesBtn.onclick = () => {
            modal.remove();
            if (onConfirm) onConfirm();
        };

        btnGroup.appendChild(noBtn);
        btnGroup.appendChild(yesBtn);
        box.appendChild(btnGroup);
        modal.appendChild(box);
        document.body.appendChild(modal);
    },

    // [NEW] Toast Notification
    showToast: function (message, duration = 3000) {
        const toast = document.createElement('div');
        toast.innerText = message;
        Object.assign(toast.style, {
            position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.9)', color: '#fff',
            padding: '12px 24px', borderRadius: '50px',
            fontSize: '1rem', fontWeight: '500', zIndex: '20002',
            boxShadow: '0 4px 15px rgba(0,0,0,0.5)', border: '1px solid rgba(255, 255, 255, 0.1)',
            opacity: '0', transition: 'opacity 0.3s ease, transform 0.3s ease'
        });

        document.body.appendChild(toast);

        // Animate In
        requestAnimationFrame(() => {
            toast.style.opacity = '1';
            toast.style.transform = 'translateX(-50%) translateY(0)';
        });

        // Remove
        setTimeout(() => {
            toast.style.opacity = '0';
            toast.style.transform = 'translateX(-50%) translateY(20px)';
            setTimeout(() => toast.remove(), 300);
        }, duration);
    }
};

window.utils = utils;

